export const IS_TEST = process.env.NODE_ENV === `test`;
export const IS_PRODUCTION = process.env.NODE_ENV === `production`;
export const WEBCAST_API = IS_PRODUCTION
  ? `https://webcast.workr.com.br/api`
  : `http://localhost/api`;
